import { useParams } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function NCUData(props) {
  const { childToParent, code } = props;
  const { t } = useTranslation();
  var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
  const params = useParams();
  const { ncu } = params;
  let number = 0;
  const [NCU, setNCU] = useState([{ trackers: 0, trackersOk: 0, trackersWarning: 0, trackersBad: 0, trackersNoComm: 0 }]);
  const [HTMLNCU, setHTMLNCU] = useState();
  const variablesAPedir = "idNCU,trackers,trackersOk,trackersWarning,trackersBad,trackersNoComm";

  useEffect(() => {
    fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/NCU?idSolarFarm=" + idParque + "&idNCU=" + ncu + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
      .then(async (data) => { setNCU(await data.json(0)); })
      .catch(e => { console.log(e); })
    var interval1 = setInterval(function () {
      number++;
      if (code == sessionStorage.getItem("key")) { // No ha cambiado de página
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/NCU?idSolarFarm=" + idParque + "&idNCU=" + ncu + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
          .then(async (data) => { setNCU(await data.json()); })
          .catch(e => { console.log(e); })
      } else { // Ha cambiado de página. Cancela bucle
        clearInterval(interval1);
      }
    }, 30000)
  }, [number, ncu]);

  useEffect(() => {
    if (NCU.length > 0) {
      var datos = NCU.map((d, index) => {
        const { trackers, trackersOk, trackersWarning, trackersBad, trackersNoComm } = d;
        return <div className='row' key={index}>
          <div className='col-sm-auto'><strong>{t('scada.solarFarm.ncu.trackers')} </strong>{trackers}</div>
          <div className='col-sm-auto'><strong>{t('scada.solarFarm.ncu.trackersOk')} </strong>{trackersOk}</div>
          <div className='col-sm-auto'><strong>{t('scada.solarFarm.ncu.trackersWarning')} </strong>{trackersWarning}</div>
          <div className='col-sm-auto'><strong>{t('scada.solarFarm.ncu.trackersAlarm')} </strong>{trackersBad}</div>
          <div className='col-sm-auto'><strong>{t('scada.solarFarm.ncu.trackersComm')}&nbsp;</strong>{trackersNoComm}</div>
        </div>
      })
      setHTMLNCU(datos);
    }
  }, [NCU])
  return (
    <div className='container-fluid'>
      {HTMLNCU}
    </div>
  )
}

export default NCUData